const ITEMS = [
  "Tawa",
  "Pressure Cooker",
  "Kadai",
  "Appachatti",
  "Tiffin Carrier",
  "Dabara",
  "Saucepan",
  "Brass Pooja",
  "Kitchen Knives",
  "Non-stick",
];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-6 font-display text-4xl italic text-stone-500 md:px-10 md:text-6xl">
          {item}
        </span>
        <span className="h-2 w-2 rotate-45 bg-brand-brass/70" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section
    data-testid="marquee"
    className="overflow-hidden border-y border-white/5 py-12 md:py-16"
  >
    <div className="animate-marquee flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);

export default Marquee;
